module.exports = __webpack_public_path__ + "img/qr-play-store.d95a375c.png";